import { render } from "./NewCanvasView.vue?vue&type=template&id=6dfa44a2&scoped=true"
import script from "./NewCanvasView.vue?vue&type=script&lang=js"
export * from "./NewCanvasView.vue?vue&type=script&lang=js"

import "./NewCanvasView.vue?vue&type=style&index=0&id=6dfa44a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfa44a2"]])

export default __exports__